var map = {
	"./prize-bar.png": "4db3",
	"./prize-top.png": "75f1",
	"./prize.png": "fb74",
	"./prize70.png": "e74d",
	"./prize77.png": "6e53",
	"./prize78.png": "d936",
	"./prize79.png": "95ab",
	"./prize80.png": "6fef",
	"./prize81.png": "adb5",
	"./prize82.png": "f9ea",
	"./prize83.png": "3606",
	"./prize84.png": "cc40",
	"./prizeundefined.png": "4ec0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5068";